export enum TradingProcedureStatusDto {
    Draft = 'Draft',
    Published = 'Published',
    Active = 'Active',
    AwaitingDecision = 'AwaitingDecision',
    Finished = 'Finished',
    Cancelled = 'Cancelled',
}
